<template>
  <template
    v-for="refinement in availableRefinements"
    :key="refinement.id"
  >
    <div
      v-for="article in refinement.articles"
      :key="refinement.id + '-' + article.id"
      class="article-row"
    >
      <div
        v-if="visibleAvailableRefinementArticles.includes(refinement.id + '-' + article.id) && !article.is_seamless_print"
        class="article-frame col-12"
      >
        <configurator-optional-booth-refinement-entry
          :refinement="refinement"
          :article="article"
          @add="handleAddOptionalRefinement"
          @remove="handleRemoveOptionalRefinement"
          @update="handleUpdateOptionalRefinement"
        />
      </div>
    </div>
  </template>
</template>
<script setup>
import { computed, reactive, ref } from 'vue'
import { useMainStore } from '@/store'
import { filterAvailableRefinements } from '@/utils/boothRefinements'


const store = useMainStore()

// define computed props
const basket = computed(() => store.settings.basket)
const shoppingCart = computed(() => store.settings.shopping_cart)
const disabledBoothRefinementArticleIds = computed(() => store.availability.disabled_booth_refinement_ids)
const bookableArticleIds = computed(() => store.availability.bookable_article_ids)
const includedCharacters = computed(() => store.tmp.characters_inclusive)

const availableRefinements = computed(() => {
  return filterAvailableRefinements(
		shoppingCart.value,
		disabledBoothRefinementArticleIds.value,
		false,
    bookableArticleIds.value
	)
})

// Compute which article is visible for which refinement
const visibleAvailableRefinementArticles = computed(() => {
  const seenArticleIds = []
  const result = []
  availableRefinements.value.forEach((refinement) => {
    refinement.articles.forEach((article) => {
      if (!seenArticleIds.includes(article.article_id)) {
        seenArticleIds.push(article.article_id)
        result.push(refinement.id + '-' + article.id)
      }
    })
  })
  return result
})

const handleAddOptionalRefinement = (refinement, article) => {
  const clonedRefinement = _.cloneDeep(refinement)
  
  // find print article 
  const index = basket.value.selectedArticles.findIndex((a) => {
    return a.id === article.article.id
  })
  if (index === -1) {
    console.warn('lettering article not found')
    return
  }
  const clonedArticle = _.cloneDeep(basket.value.selectedArticles[index])

  // TODO: count remaining included characters

  // TODO: inclusive check
  clonedArticle.count = 1
  clonedArticle.count_after_inclusive = 0
  clonedArticle.inclusive = 0

  shoppingCart.value.addBoothRefinementArticle(clonedArticle, clonedRefinement)
}

/**
 * Handles decrementing (and removing if count after decrement is <= 0) the article for the given 
 * refinement in the shopping cart
 * 
 * @param refinement the refinement
 * @param article the article
 */
const handleRemoveOptionalRefinement = (refinement, article) => {
  shoppingCart.value.decreaseBoothRefinementArticle(refinement.id, article.article.id)
}

/**
 * Handles updating the count of an article for a given refinement in the shopping cart
 * 
 * @param refinement the refinement
 * @param article the article
 * @param count the updated count
 */
const handleUpdateOptionalRefinement = (refinement, article, count) => {
  console.info("handling update", {count: count, refinement: refinement.id, article:article.article.id})
  // Check if the article already exists in shopping cart, if not, create it first
  const index = shoppingCart.value.print_items.findIndex((printItem) => 
    printItem.booth_refinement_id === refinement.id && printItem.id === article.article.id
  )
  if (count > 0 && index === -1) {
    console.log("Adding initial refinment entry")
    handleAddOptionalRefinement(refinement, article);
  }

  // Update the count, removing, if 0
  shoppingCart.value.updateBoothRefinementArticleCount(refinement.id, article.article.id, count)
}
</script>